﻿<template>
    <div class="q-pa-md q-gutter-sm">
        <q-breadcrumbs>
            <q-breadcrumbs-el icon="home" to="/" />
            <q-breadcrumbs-el :label="props.label" :to="props.extraBreadcrumb ? props.to : null" />
            <q-breadcrumbs-el :label="props.extraBreadcrumb" v-if="props.extraBreadcrumb" />
        </q-breadcrumbs>
    </div>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

interface Props {
    label?: string
    extraBreadcrumb?: string
    to?: RouteLocationRaw
}

const props = withDefaults(defineProps<Props>(), {
    label: '',
    extraBreadcrumb: '',
    to: null,
})
</script>
